module.exports = __webpack_public_path__ + "media/audio46.3720fa64.mp3";